export default __webpack_public_path__ + "static/favicon-eb30d0bdf9107d8cda31a113d880c1e0.png";